const switchButton = {
  defaultProps: {
    disableRipple: true,
  },
};

export default switchButton;
